import ContentLoader from "react-content-loader";

const PostCardSkeleton = (props) => (
  <ContentLoader
    speed={2}
    height={338}
    viewBox="0 0 321 338"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
    style={{
      backgroundColor: "white", borderRadius: 16,
      boxShadow: "0px 6px 12px 0px rgba(0, 0, 0, 0.12)"
    }}
  >
    {/* Card container with shadow
    <rect x="0" y="0" rx="16" ry="16" width="295" height="338" fill="#ffffff" stroke="#e0e0e0" strokeWidth="1" /> */}

    {/* Image placeholder */}
    <rect x="0" y="0" rx="0" ry="16" width="100%" height="124" fill="#f0f0f0" />

    {/* Title placeholder */}
    <rect x="18" y="146" rx="4" ry="4" width="200" height="22" fill="#f0f0f0" />
    <rect x="18" y="170" rx="4" ry="4" width="150" height="22" fill="#f0f0f0" />

    {/* Statistics section */}
    <rect x="18" y="220" rx="4" ry="4" width="120" height="28" fill="#f0f0f0" />
    <rect x="18" y="250" rx="4" ry="4" width="80" height="14" fill="#f0f0f0" />

    <rect x="155" y="220" rx="4" ry="4" width="120" height="28" fill="#f0f0f0" />
    <rect x="155" y="250" rx="4" ry="4" width="100" height="14" fill="#f0f0f0" />

    {/* Action buttons at bottom */}
    <rect x="18" y="280" rx="8" ry="8" width="120" height="41" fill="#f0f0f0" />
    <rect x="161" y="280" rx="8" ry="8" width="1" height="41" fill="#f0f0f0" />
    <rect x="183" y="280" rx="8" ry="8" width="120" height="41" fill="#f0f0f0" />
  </ContentLoader>
);

export default PostCardSkeleton;
